import { useState, useRef, useEffect } from 'react'
import { useFloating, offset, flip, shift } from '@floating-ui/react'
import { Button } from '../ui/button'
import { Icon } from '../ui/icon'

interface CollapsedMenuProps {
  children: React.ReactNode
}

export function CollapsedMenu({ children }: CollapsedMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const floatingRef = useRef<HTMLDivElement | null>(null)

  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-end',
    middleware: [offset(8), flip(), shift({ padding: 8 })],
  })

  useEffect(() => {
    if (!isOpen) return
    const handler = (e: MouseEvent) => {
      if (floatingRef.current && !floatingRef.current.contains(e.target as Node)) {
        const btn = refs.reference.current as HTMLElement | null
        if (btn && btn.contains(e.target as Node)) return
        setIsOpen(false)
      }
    }
    document.addEventListener('click', handler)
    return () => document.removeEventListener('click', handler)
  }, [isOpen, refs.reference])

  return (
    <>
      <Button
        elementRef={refs.setReference}
        onClick={() => setIsOpen(!isOpen)}
        active={isOpen}
        className={isOpen ? '' : 'text-fg-secondary hover:text-fg-primary'}
      >
        <Icon icon="dots" size={20} />
      </Button>
      {isOpen && (
        <div
          ref={(el) => {
            refs.setFloating(el)
            floatingRef.current = el
          }}
          style={floatingStyles}
          className="z-[9999] bg-bg-surface border border-border-default rounded-xl shadow-2xl p-3 animate-in fade-in slide-in-from-bottom-2 duration-200"
        >
          {children}
        </div>
      )}
    </>
  )
}
